// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FCm2","name":"styles_name__39COa","phone":"styles_phone__1QWn7"};